<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <router-link to="/usuarios" class="text-muted">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>
          </div>
        </div>
        <div class="col-md-6 offset-md-3">
          <div class="card mb-3">
            <div class="card-header">
              <h5 class="card-title mb-0">Usuario</h5>
            </div>
            <div class="card-body text-center">
              <img
                src="assets/img/user_membresia.png"
                alt="Usuario"
                class="img-fluid rounded-circle mb-2"
              />

              <h4 class="mb-0 fw-bold text-orange">
                {{ usuario.nombres }}
              </h4>
              <div class="mt-3">
                <span
                  v-if="usuario.estad_registro == 0"
                  class="badge bg-primary"
                  >Interesado</span
                >
                <span v-if="usuario.estad_registro == 1" class="badge bg-danger"
                  >Pendiente</span
                >
                <span
                  v-if="usuario.estad_registro == 2"
                  class="badge bg-success"
                  >Completa</span
                >
                <span
                  v-if="usuario.estad_registro == 3"
                  class="badge bg-warning"
                  >Exitosa</span
                >
              </div>
            </div>
            <hr class="my-0" />
            <div class="card-body">
              <div class="d-grid gap-2">
                <router-link
                  v-bind:to="'/usuario/info_basica/' + id_usuario"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Información básica
                </router-link>
                <router-link
                  v-bind:to="'/beneficiarios/' + id_usuario"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Beneficiarios
                </router-link>
                <router-link
                  v-bind:to="'/pago/' + id_usuario"
                  class="btn btn-outline-primary btn-lg rounded-pill"
                >
                  Pago
                </router-link>
                <button class="btn btn-outline-primary btn-lg rounded-pill">
                  Contrato
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Usuario",
  metaInfo: {
    title: "Usuarios - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      id_usuario: null,
      usuario: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    generar_contrato() {
      window.open(
        this.$base_url + "download/contrato_usuario/" + this.id_usuario,
        "_blank"
      );
    },
  },
  mounted: function () {},
};
</script>